import { render, staticRenderFns } from "./imports_wizard_bulk.vue?vue&type=template&id=b9353ade&"
import script from "./imports_wizard_bulk.vue?vue&type=script&lang=js&"
export * from "./imports_wizard_bulk.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports